import type { CentroCustoApi } from "../types/centro-custo.types";
import {
  garantirCentroCustoEvento,
  listarCentrosCusto,
} from "../services/centro-custo.service";

/**
 * Resolve o id do centro de custo vinculado ao evento (cria se ainda não existir).
 */
export async function resolverCentroCustoIdEvento(
  eventoId: number,
  centrosAtuais?: CentroCustoApi[] | null,
): Promise<string> {
  const lista =
    centrosAtuais ??
    (await listarCentrosCusto({ ativo: true })).data ??
    [];
  const existente = lista.find((c) => c.eventoId === eventoId);
  if (existente?.id) return existente.id;

  const { data, status } = await garantirCentroCustoEvento(eventoId);
  if (status === 200 && data?.id) return data.id;
  return "";
}
